<template>
  <div id="chart-line" v-loading="chartLoading">
      <div style="width:100p%; text-align:center;">
    <div
      id="plotly"
      ref="plotly"
      style="
      margin: 0 auto;
      width:100%;
      height:400px;
      text-alin:center;
      "
    />
</div>
      <ChartTimeMini
  :rawData="rawData"
  :samplingRate="samplingRate"
  v-model="visibleRange"
  ></ChartTimeMini>
    <el-row class="toolbox">
      <el-col>
        <el-form
          ref="form"
          inline
          label-position="top"
          label-width="100px"
          size="small"
        >
          <el-form-item :label="$t('measurement.window')">
            <el-select v-model="window">
              <el-option
                v-for="window in windows"
                :key="window"
                :label="window"
                :value="window"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('measurement.nfft')">
            <el-select v-model="nfft">
              <el-option
                v-for="n in [256,512,1024,2048,4096,8192,16384]"
                :key="n"
                :label="n"
                :value="n"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Plotly from "./Plotly"
import cachios from "cachios";
import ChartTimeMini from "./Chart_TimeMini"
export default {
  name: "spectrogram-chart",
  events: [],
  props: {
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ChartTimeMini
  },
  data() {
    return {
      chartLoading:true,
     series: [
        {
          x: [],
          y: [],
          z: [],
        },
      ],
      nfft:2048,
      visibleRange:[],
      window:"rectangular",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
       layout: {
        xaxis: {
          title: {
            text: `${this.$t('measurement.time')}`,
          },
        },
        yaxis: {
          title: {
            text: `${this.$t('chart.fFrequency')}`,
          },
        },
        zaxis: {
    type: 'log',
    autorange: true
  },
        height: 400,
        margin: {
          l: 50,
          r: 50,
          b: 50,
          t: 30,
          pad: 0,
        },
        displaylogo: false,
      },
       modebar: {
          orientation: "v",
        },
    };
  },
  mounted() {
    this.visibleRange = [0,this.rawData.length-1]
    window.addEventListener("mousedown", this.mouseDown);
  },
  methods: {
  
    mouseDown(e) {
      this.mouseBeforeX = e.offsetX;
    },
    init() {
       this.chartLoading = true;
      cachios
        .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/spectrogram`, {
          window:this.window,
          dcOffset: true,
          nfft:this.nfft,
          signal: this.rawData.slice(this.visibleRange[0],this.visibleRange[1]),
          samplingRate: this.samplingRate,
        })
        .then((response) => {

          this.f = response.data.results.f;
          this.t = response.data.results.t;
          this.sxx = response.data.results.sxx;
          // console.log(this.f,this.t,this.sxx)
          this.updateChart()

        }).finally(()=>{
      this.chartLoading = false;

        });
    },
  updateChart() {

      this.series = [
        {
          x: this.t,
          y: this.f,
          z: this.sxx,
          colorscale: 'Jet',
          type: 'heatmap',

    hoverongaps: false
        },
      ];
       Plotly.newPlot(this.$refs.plotly, this.series, this.layout, {
            displayModeBar: true,
            displaylogo: false,
            doubleClick: "reset",
            responsive: true,
          });


    }
  },
  watch: {
      visibleRange:function(range){
        this.init();
    },
    rawData: function () {
      this.init();
    },
    nfft: function () {
      this.init();
    },
    window: function () {
      this.init();
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
.measurementDelete {
  float: right;
}
*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}
.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}
.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}
.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
